import React, { Component } from 'react';
import Navbar from './Navbar'
import {ListContacts} from './Contact'

class Home extends Component {

	handleOnClick(target)
	{
			// get element and scroll the element into view
			var el = document.getElementById(target)
			el.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"})
	}

	componentDidMount() {
		// Get all "navbar-burger" elements
		const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);
		
		// Check if there are any navbar burgers
		if ($navbarBurgers.length > 0) {

				// Add a click event on each of them
				$navbarBurgers.forEach( el => {
						el.addEventListener('click', () => {
		
						// Get the target from the "data-target" attribute
						const target = el.dataset.target;
						const $target = document.getElementById(target);

						// setTimeout(function(){
						// 	el.classList.toggle('is-active');
						// 	$target.classList.toggle('is-active');
						// }, 2000);
		
						// Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
						el.classList.toggle('is-active');
						$target.classList.toggle('is-active');
						});
				});
		}

		this.closePageLoader()
	}

	closePageLoader() {
		setTimeout(function(){ 
			var loader = document.querySelector('div#home div.pageloader')
			loader.classList.toggle('is-active')
		}, 2000);
	}

	render() {
		return (
			<div id="home" className="animated fadeIn delay-1s">
				<div className="pageloader is-active is-black"></div>

				<section className="hero is-bold is-fullheight">

					<div className="hero-head">
						<Navbar/>
					</div>

					<div className="hero-body padding-two-top">

						<div className="container">
							<div className="columns">
								<div className="column is-four-fifths has-text-left has-text-centered-mobile">
									<p className="subtitle has-text-weight-bold is-size-6-mobile has-text-dark is-heading animated fadeIn delay-2s">
										Hello World!
									</p>
									<p className="title padding-two-top is-huge has-text-dark is-size-1 is-name animated fadeIn delay-2s">
										I'm Akshay Patel
									</p>
									<p className="subtitle padding-two-top has-text-weight-bold has-text-white is-size-5 is-size-6-mobile padding-half-top is-family-code animated fadeIn delay-2s">
										STUDENT & SOFTWARE DEVELOPER
									</p>
									{/* <div className="container has-text-right is-size-5">
										<a name="about" className="button is-dark is-fullwidth is-outlined" onClick={(e) => this.handleOnClick(e.target)}>
												FIND OUT MORE
										</a>
										<a class="button is-fullwidth">Normal</a>
									</div> */}
								</div>
								<div className="column padding-two-top has-text-right is-hidden-mobile">
									<ListContacts hover={'links'} color="dark"/>
									{/* <nav className="tabs is-large is-size-6-mobile is-centered" aria-label="breadcrumbs">
										
									</nav> */}
								</div>
							</div>

							{/* <div className="columns">
								<div className="column is-four-fifths has-text-left">
								</div>

								<div className="column has-text-right">
									<ListContacts hover={'links'} color="dark"/>
								</div>
								</div>
							</div> */}
						</div>
					</div>
				
					<div className="hero-foot column">
						<div className="container">
							<div className="columns">
								<div className="column has-text-left has-text-centered-mobile">
									<a name="about" className="button has-text-white is-medium is-dark animated fadeInUp delay-2s" onClick={(e) => this.handleOnClick('about')}>
										<span className="icon">
											<i className="fas fa-angle-double-down"></i>
										</span>
									</a>
								</div>
								<div className="column has-text-right">
									{/* <ListContacts hover={'links'} color="dark"/> */}
									{/* <nav className="tabs is-large is-size-6-mobile is-right" aria-label="breadcrumbs">
										<ListContacts hover={'links'} color="dark"/>
									</nav> */}
								</div>
							</div>
						</div>
					</div>

				</section>

				{/* <section className="hero is-fullheight">
					<div className="hero-body">						
						<div className="container has-text-centered">
							<div className="column">
								<p className="title is-size-3-mobile is-size-2-tablet is-size-1-desktop has-text-weight-bold">
									"A good programmer is someone who always looks both ways before crossing a one-way street."
								</p>
							</div>
							<div className="column">
								<p className="title is-size-5-mobile is-size-4-tablet is-size-3-desktop has-text-weight-light is-italic has-text-right">
									- Doug Linder
								</p>
							</div>
							<div className="column">
								<nav className="breadcrumb is-centered has-bullet-separator" aria-label="breadcrumbs">
									<ListContacts color="black"/>
								</nav>
							</div>
						</div>
					</div>
					
					<div className="hero-foot">
						
						<div className="column has-text-centered">
							<a href="#About" name="about" className="button is-black" onClick={(e) => this.handleOnClick(e.target)}>
									FIND OUT MORE
							</a>
						</div>
						<div className="container"></div>
					</div>
				</section> */}
			</div>
		);
	}
}

export default Home;